export default {
  setProjectTypes(state, data) {
    state.projectTypes = data;
  },
  setProjectTypeCode(state, data) {
    state.projectTypeCode = data;
  },

  setProjects(state, data) {
    state.projects = data;
  },
  setProject(state, data) {
    state.project = data;
  },
  setProjectId(state, data) {
    state.projectId = data;
  },
  setProjectCode(state, data) {
    state.projectCode = data;
  },

  setWorkDescriptions(state, data) {
    state.workDescriptions = data;
  },
  setWorkDescriptionCode(state, data) {
    state.workDescriptionCode = data;
  },

  setProjectTeams(state, data) {
    state.projectTeams = data;
  },

  setGeneralEstimates(state, data) {
    state.generalEstimates = data;
  },

  setBuildingProject(state, data) {
    state.buildingProject = data;
  },

  setUnits(state, data) {
    state.units = data;
  },
  setUnitCode(state, data) {
    state.unitCode = data;
  },
  setSuiteId(state, data) {
    state.suiteId = data;
  },

  setSuites(state, data) {
    state.suites = data;
  },
  setSuitCode(state, data) {
    state.suitCode = data;
  },

  setParticipation(state, data) {
    state.participation = data;
  },
  setParticipationCode(state, data) {
    state.participationCode = data;
  },
  setParticipationId(state, data) {
    state.participationId = data;
  },

  setPaymentNotification(state, data) {
    state.paymentNotification = data;
  },
  setPaymentNotificationCode(state, data) {
    state.paymentNotificationCode = data;
  },

  setRank(state, data) {
    state.rank = data;
  },
  setRankCode(state, data) {
    state.rankCode = data;
  },

  setEstimation(state, data) {
    state.estimation = data;
  },
  setEstimationCode(state, data) {
    state.estimationCode = data;
  },
  setEstimationItem(state, data) {
    state.estimationItem = data;
  },
  setEstimationId(state, data) {
    state.estimationId = data;
  },

  setTransfer(state, data) {
    state.transfer = data;
  },
  setTransferCode(state, data) {
    state.transferCode = data;
  },

  setCrimesReward(state, data) {
    state.crimesReward = data;
  },
  setCrimesRewardCode(state, data) {
    state.crimesRewardCode = data;
  },

  setCrimesRewardSubject(state, data) {
    state.crimesRewardSubject = data;
  },
  setCrimesRewardSubjectCode(state, data) {
    state.crimesRewardSubjectCode = data;
  },

  setEstimationSubject(state, data) {
    state.estimationSubject = data;
  },
  setEstimationSubjectCode(state, data) {
    state.estimationSubjectCode = data;
  },

  setSetting(state, data) {
    state.setting = data;
  },

  setBlocks(state, data) {
    state.blocks = data;
  },
  setBlockCode(state, data) {
    state.blockCode = data;
  },

  setRankingReport(state, data) {
    state.rankingReport = data;
  },

  setRankingDetailReport(state, data) {
    state.rankingDetailReport = data;
  },

  setSmsSetting(state, data) {
    state.smsSetting = data;
  },

  setSendSms(state, data) {
    state.sendSms = data;
  },

  setPaymentNotificationLog(state, data) {
    state.paymentNotificationLog = data;
  },
};
